import { PageHeader } from "@/components/common";
import { QuoteEstimator } from "@/components/pricing/QuoteEstimator";
import { PricingSheet } from "@/components/pricing/PricingSheet";

export default function PricingPage() {
  return (
    <div data-testid="pricing-page">
      <PageHeader title="Pricing" subtitle="AI quote estimator for sales staff, backed by the editable pricing sheet and every job in the system." />
      <QuoteEstimator />
      <PricingSheet />
    </div>
  );
}
